<template>
  <el-dialog
    :visible="!!editingProject"
    :title="disalbed ? '查看项目' : '编辑项目'"
    width="1000px"
    @close="closeDialog"
  >
    <el-form :model="detail" ref="form" :rules="rules" label-width="140px">
      <el-form-item label="申购币种：" prop="coinType">
        <el-select v-model="detail.coinType" placeholder="请选择">
          <el-option
            v-for="item in coinTypeList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="总量：" prop="totalAmount">
        <el-input-number
          v-model="detail.totalAmount"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="最小申购数量：" prop="minAmount">
        <el-input-number v-model="detail.minAmount" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="最大申购数量："
        prop="maxAmount"
        v-if="detail.type == 1"
      >
        <el-input-number v-model="detail.maxAmount" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="最大小数位精度：" prop="precisions">
        <el-input-number v-model="detail.precisions" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="官网地址："
        prop="officialUrl"
        v-if="detail.type == 1"
      >
        <el-input v-model="detail.officialUrl"></el-input>
      </el-form-item>
      <el-form-item
        label="白皮书地址："
        prop="whiteUrl"
        v-if="detail.type == 1"
      >
        <el-input v-model="detail.whiteUrl"></el-input>
      </el-form-item>
      <el-form-item label="起止时间：" required>
        <el-col :span="7">
          <el-form-item prop="startTime">
            <el-date-picker
              v-model="detail.startTime"
              value-format="timestamp"
              type="datetime"
              placeholder="选择开始时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="endTime">
            <el-date-picker
              v-model="detail.endTime"
              value-format="timestamp"
              type="datetime"
              placeholder="选择截止时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item
        label="支持币种："
        prop="supportCoin"
        v-if="detail.type == 0"
      >
        <mutiple-input v-model="detail.supportCoin" />
        <!-- <el-select v-model="detail.distributionCoinType" placeholder="请选择" disabled>
            <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
        </el-select>-->
      </el-form-item>
      <el-form-item
        label="支持币种："
        prop="supportCoin"
        v-if="detail.type == 1"
      >
        <div class="three-coin">
          <el-input
            v-model="detail.supportCoin[0].coin"
            class="disinput"
            disabled="disabled"
          ></el-input>
          <el-input-number
            v-model="detail.supportCoin[0].price"
            :min="0"
          ></el-input-number>
          <el-input
            v-model="detail.supportCoin[0].cof"
            class="disinputs"
            disabled="disabled"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="币种图标(png)：" prop="listImageUrl">
        <upload
          v-model="detail.signUrl"
          :data="{ category: 'purchase' }"
        ></upload>
      </el-form-item>
      <el-form-item label="详情页横幅图片：" prop="bannerUrl">
        <upload
          v-model="detail.bannerUrl"
          :data="{ category: 'purchase' }"
        ></upload>
      </el-form-item>
      <el-form-item label="列表页缩略图片：" prop="listImageUrl">
        <upload
          v-model="detail.listImageUrl"
          :data="{ category: 'purchase' }"
        ></upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button v-if="!disalbed" type="primary" @click="handleSave()"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';
import MutipleInput from '../mutipleInput';

export default {
  name: 'purchaseProjectDetail',
  data() {
    const validateEndTime = (rule, value, callback) => {
      if (!this.detail.endTime) {
        callback(new Error('请填写'));
      }
      if (
        this.detail.startTime &&
        this.detail.endTime &&
        value < this.detail.startTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };
    const validateStartTime = (rule, value, callback) => {
      if (!this.detail.startTime) {
        callback(new Error('请填写'));
      }
      if (this.detail.startTime < new Date())
        callback(new Error('开始时间不得早于当前时间'));
      callback();
    };

    return {
      detail: {},
      rules: {
        coinType: {
          required: true,
          message: '请填写'
        },
        totalAmount: {
          required: true,
          message: '请填写'
        },
        minAmount: {
          required: true,
          message: '请填写'
        },
        startTime: [
          {
            validator: validateStartTime,
            trigger: 'change'
          }
        ],
        endTime: [
          {
            validator: validateEndTime,
            trigger: 'change'
          }
        ],
        supportCoin: {
          required: true,
          message: '请填写'
        },
        signUrl: {
          required: true,
          message: '请填写'
        },
        bannerUrl: {
          required: true,
          message: '请填写'
        },
        listImageUrl: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  computed: {
    ...mapState('purchaseProject', [
      'coinTypeList',
      'editingProject',
      'languageList'
    ]),
    disalbed() {
      return this.detail && this.detail.status !== 0;
    }
  },
  watch: {
    editingProject(val) {
      this.detail = val || {};
    }
  },
  components: {
    Editor,
    Upload,
    MutipleInput
  },
  methods: {
    ...mapMutations('purchaseProject', ['setEditingProject']),
    ...mapActions('purchaseProject', ['update']),
    closeDialog() {
      this.setEditingProject(null);
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.update(this.detail).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>
